import * as React from 'react';
import { SelectReact } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
import { useTranslation } from 'common/i18n/hooks';
import { useDataGroups } from 'common/contexts/react/data-group-context';
import { ButtonSize } from 'common/components/button/constants';
import { DEFAULT_DATA_GROUP } from 'common/widgets/data-group-selector';
import { ChangeEvent } from 'common/components/select/types';
import { Directions } from 'common/components/drop-menu/types';
type DataGroupSelectProps = {
  selectedDataGroup?: string | null;
  onSelect: (dataGroupId: string) => void;
};

/** A wrapper around SelectReact for selecting a data group inline for a metric in the query
 * builder.
 *
 * Returns null if dataGroupsStore isn't populated or there are none. */
export function DataGroupSelect(props: DataGroupSelectProps) {
  var _dataGroups$find;
  const dataGroupStore = useDataGroups();
  const {
    t
  } = useTranslation();
  const selectedId = props.selectedDataGroup ? props.selectedDataGroup : null;
  if (!dataGroupStore.value || Object.values(dataGroupStore.value).length === 0) {
    return null;
  }
  const dataGroups = [DEFAULT_DATA_GROUP, ...Object.values(dataGroupStore.value)];
  const items = dataGroups.map(dataGroup => {
    const label = dataGroup.groupID === DEFAULT_DATA_GROUP.groupID ? t("query-builder.dg-user") : dataGroup.displayName;
    return {
      isDisabled: !dataGroup.isReady,
      isSelected: selectedId === dataGroup.groupID,
      label,
      tooltip: dataGroup.displayName.length > 12 ? {
        text: dataGroup.displayName
      } : undefined,
      value: dataGroup.groupID
    };
  });
  const userGroupSelected = selectedId === DEFAULT_DATA_GROUP.groupID;
  const selectedLabel = userGroupSelected ? t("query-builder.dg-user") : (_dataGroups$find = dataGroups.find(dataGroup => dataGroup.groupID === selectedId)) === null || _dataGroups$find === void 0 ? void 0 : _dataGroups$find.displayName;
  const tooltipText = userGroupSelected ? t("data-groups.analyze-by-users-tooltip") : t("data-groups.analyze-by-dg-tooltip");
  const tooltip = {
    text: "".concat(tooltipText, "\n[").concat(t("common.learn-more"), "](https://help.mixpanel.com/hc/en-us/articles/360025333632)")
  };
  return <SelectReact alwaysShowCaret className='data-group-select' label={selectedLabel} tooltip={tooltip} theme={SelectTheme.Tertiary} size={ButtonSize.Small} menuAlignment={Directions.DownRight} menuWidth={120} elref='dataGroupSelect' sections={[{
    items
  }]} onChange={ev => props.onSelect((ev as ChangeEvent).detail.item.value)} data-sentry-element="SelectReact" data-sentry-component="DataGroupSelect" data-sentry-source-file="index.tsx" />;
}